import { memo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import GaugeChart from 'react-gauge-chart';

import { Tooltip } from 'antd';

import { useTheme } from '@/shared/lib/hooks';

import cls from './gauge.module.css';

interface GaugeProps {
    score: number;
    minValue: number;
    maxValue: number;
}

export const Gauge = memo((props: GaugeProps) => {
    const { score, minValue, maxValue } = props;

    const isDarkTheme = useTheme()[2];

    // Map score from [minValue, maxValue] to [0, 1] for gauge display
    const normalizedScore = (score - minValue) / (maxValue - minValue);

    return (
        <Tooltip
            placement="top"
            title={`${score}`}
        >
            <div className={cls.container}>
                <GaugeChart
                    arcWidth={0.35}
                    className={cls.gauge}
                    colors={[
                        '#D32029',
                        '#D87A16',
                        '#E8D639',
                        '#52C41A',
                        '#306317',
                    ]}
                    cornerRadius={2}
                    hideText
                    marginInPercent={0}
                    needleBaseColor={isDarkTheme ? '#FFF' : '#000'}
                    needleColor={isDarkTheme ? '#FFF' : '#000'}
                    nrOfLevels={5}
                    percent={normalizedScore}
                />
            </div>
        </Tooltip>
    );
});

Gauge.displayName = 'Gauge';
